import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WindowRef } from '../../common/helpers';
import { ApplicationConfig } from '../../config/config';
import { ContentLogo } from '../../model/content/contentLogo.model';
import { ContentMyDelta } from '../../model/content/contentmydelta.model';
import { ContentSessionTimeOut } from '../../model/content/contentsessiontimeout.model';
import { TrackerDataService } from '../../services/acctactvty/trackerData.service';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { LogoutService } from '../../services/logout/logout.service';

@Component({
  selector: 'ngc-session-time-out',
  templateUrl: './session-time-out.component.html'
})
export class SessionTimeOutComponent
  implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy
{
  isModalShown = false;
  aemErrorMessages: any;
  config = {
    animated: false
  };

  countDown;
  remSecs = 0;
  remMins = 0;

  @Input() contentSessionTimeOut: ContentSessionTimeOut;
  public closeTimer = null;
  public displayModal = 300;
  public secondsRemaining = 300;
  public expireSession = 0;
  public timeoutURL = this.appConfig.get('APP_SESS_CUSTOMER_LOGOUT_URL');
  public expireSessionUrl = this.appConfig.get('APP_SESS_CUSTOMER_LOGOUT_URL');
  public keepSessionAliveURL = this.appConfig.get('APP_SESS_CUSTOMER_DATA_URL');
  // public stopRefreshSession = false;
  public logintimeout_tid: any;
  public showSessionTimeOut: any;
  public showRemainingTimer: any;
  public myDeltaContent: ContentMyDelta;
  contentHeaderFooterServiceSubscribe: Subscription;
  logOutServiceSubscribe: Subscription;
  loginPageURL: string;
  public refreshURL: string;
  @Input() redirectFromCallingApp: boolean;
  @Output() notifyBack: EventEmitter<void> = new EventEmitter();
  @ViewChild('loginForm') loginForm: ElementRef;
  private data: any;
  private errorData: any;
  private stopRefreshSession = true;
  private observable: Observable<any>;
  private observableError: Observable<any>;
  private unsubscribe: Subject<void> = new Subject();
  private APP_SESS_TIME_OUT: number;
  private contentLogoData: ContentLogo;
  private slimheaderLogoUrl: string;
  @Input() useContent: boolean;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private windowRef: WindowRef,
    private http: HttpClient,
    private appConfig: ApplicationConfig,
    private trackService: TrackerDataService,
    private commonService: CommonService,
    private contentService: ContentHeaderFooterService,
    public el: ElementRef,
    private renderer: Renderer2,
    private dragModal: CommonService,
    private logOutService: LogoutService,
    private loggingService: LoggingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.APP_SESS_TIME_OUT = Number.parseInt(
      this.appConfig.get('APP_SESS_TIME_OUT')
    );
  }

  ngOnInit() {
    const setTimerData = timer(0, 1000);
    this.showRemainingTimer = setTimerData.subscribe((x) => {
      this.remSecs = this.secondsRemaining--;
      // tslint:disable-next-line:no-bitwise
      this.remMins = ~~(this.remSecs / 60);
      this.remSecs -= this.remMins * 60;
      if (this.secondsRemaining <= 0) {
        this.logMeOut();
        return true;
      }
    });
    if (
      (this.contentService.contentHeaderFooter && !this.useContent) ||
      (!this.contentSessionTimeOut && this.useContent)
    ) {
      this.contentHeaderFooterServiceSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                const contentData = data;
                if (contentData.logo !== undefined) {
                  this.contentLogoData = contentData.logo;
                  if (this.contentLogoData.slimheaderLogoUrl !== undefined) {
                    this.slimheaderLogoUrl =
                      this.contentLogoData.slimheaderLogoUrl;
                  }
                }
                this.contentSessionTimeOut = data.sessionTimeoutMessage;
                this.myDeltaContent = data.header.auxiliaryNavigation.get(
                  'myFlightPanel'
                )
                  ? data.header.auxiliaryNavigation.get('myFlightPanel').details
                  : null;
                if (
                  this.contentSessionTimeOut.sessionTimeoutMessageDescription.indexOf(
                    '.'
                  ) !== -1
                ) {
                  this.contentSessionTimeOut.timeoutStayLogInText =
                    this.contentSessionTimeOut.sessionTimeoutMessageDescription
                      .split('.')[1]
                      .trim();
                  this.contentSessionTimeOut.sessionTimeoutMessageDescription =
                    this.contentSessionTimeOut.sessionTimeoutMessageDescription.split(
                      '.'
                    )[0];
                  this.contentSessionTimeOut.sessionTimeoutMessageDescription =
                    this.contentSessionTimeOut.sessionTimeoutMessageDescription
                      .split('{{')[0]
                      .trim();
                }
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
  }

  ngAfterViewInit() {
    this.dragModal.trapFocusInsideModal(this.el);
  }

  ngAfterViewChecked() {
    const sessiontimeoutwindow = document.body.querySelector(
      'modal-container .modal-dialog.session-time-out'
    );
    if (sessiontimeoutwindow !== null && sessiontimeoutwindow !== undefined) {
      this.renderer.setAttribute(
        sessiontimeoutwindow.parentElement,
        'aria-label',
        'Alert: ' + this.contentSessionTimeOut.sessionTimeoutMessageTitle
      );
    }
  }

  logOutAndRedirect() {
    if (isPlatformBrowser(this.platformId) && document) {
      if (this.refreshURL === undefined || this.refreshURL === null) {
        this.getRefreshURLForVacations();
      }
      this.logOutServiceSubscribe = this.logOutService
        .logOutAction(this.myDeltaContent.logoutUrl)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          async () => {
            await this.logOutService.pingLogOut(false, this.refreshURL);
            this.bsModalRef.hide();
          },
          (err) => {
            this.bsModalRef.hide();
            window.location.replace('/');
            this.loggingService.log('Caught Error: ' + err);
          }
        );
    }
    clearInterval(this.closeTimer);
    this.closeTimer = null;
  }

  logMeOut() {
    if (!this.redirectFromCallingApp) {
      this.logOutAndRedirect();
    } else {
      this.bsModalRef.hide();
      this.notifyBack.emit();
    }
  }

  getRefreshURLForVacations() {
    this.refreshURL = window.location.pathname.includes('delta-vacation')
      ? this.slimheaderLogoUrl
      : this.refreshURL;
  }

  async keepLoggedIn() {
    const bodyScroll = document.documentElement.scrollTop;
    if (this.stopRefreshSession) {
      this.dragModal.setLoginSessionRefreshVal(true);
      const resObs = this.trackService.refreshSession();
      if (
        this.dragModal.checkPath() &&
        this.dragModal.checkPath().indexOf('/need-help/overview') !== 1
      ) {
        if (
          document.body.querySelector(
            'button.idp_dialog__close.idp_dialog__close--dark'
          )
        ) {
          this.dragModal.reqActiveEle = document.body.querySelector(
            'button.idp_dialog__close.idp_dialog__close--dark'
          );
          if (this.dragModal.reqActiveEle) {
            this.dragModal.reqActiveEle.focus();
          }
        }
      }
      const pfCookieValue = '';
      // await this.commonService.getPfCookieValue().then((data) => {
      //   if (data) {
      //     pfCookieValue = data;
      //   }
      // });
      if (pfCookieValue) {
        this.loginPageURL = '/login/loginPage';
        this.loginForm.nativeElement.action = this.loginPageURL;
        this.loginForm.nativeElement.refreshURL.value = window.location.href;
        this.loginForm.nativeElement.submit();
        this.bsModalRef.hide();
      } else {
        this.bsModalRef.hide();
        await this.logOutService.keepMeLoggedIn();
      }
    }
  }

  close() {
    this.bsModalRef.hide();
  }

  ngOnDestroy() {
    if (this.showRemainingTimer) {
      this.showRemainingTimer.unsubscribe();
    }
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.showSessionTimeOut) {
      this.showSessionTimeOut.unsubscribe();
    }
    if (this.logOutServiceSubscribe) {
      this.logOutServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.stopRefreshSession = false;
  }
}
